import { FC, useContext, useEffect, useLayoutEffect, useState, } from "react";
import { EOBsFetchFile, ShowPdfProps } from "src/pages/EOBsDetail/types";
import PdfViewer from "../pdfViewer";
import { APIEndpoints } from "src/types/apiTypes";
import { LoaderContext } from "src/context/loaderContext";
import useFetch from "src/hooks/useFetch";



const ViewPdf: FC<ShowPdfProps> = ({ id,onClose }): JSX.Element => {

 
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [PDF,setPDF] = useState<string>();

  useLayoutEffect(() => {
    setLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { data: fetchEOBsFile,error:fetchEOBFileError } =
    useFetch<EOBsFetchFile>(APIEndpoints.FETCH_EOB_FILE, {}, { id });

  useEffect(() => {
    if (fetchEOBsFile) {
      setPDF(fetchEOBsFile.redacted_file)
      hideLoader();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchEOBsFile]);

  useEffect(() => {
    if (fetchEOBFileError) {
      //setPDF(fetchEOBsFile.redacted_file)
      hideLoader();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchEOBFileError]);



  useEffect(() => {

    if (PDF) {
      // Convert Base64 to binary data
      const byteCharacters = atob(PDF);
      const byteNumbers = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      // Create a Blob and Object URL
      const blob = new Blob([byteNumbers], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);

      // Cleanup function to revoke the object URL
      return () => URL.revokeObjectURL(url);
    }
  }, [PDF])

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        ['p', 's', 'u'].includes(e.key.toLowerCase())
      ) {
        e.preventDefault(); // Block print, save, view source
      }

      if (e.key === "Escape") {
        e.preventDefault(); // Block Esc key closing
      }

      // Optional: block F12
      if (e.key === "F12") {
        e.preventDefault();
      }
    };

    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault(); // Disable right-click
    };

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ''; // Required for modern browsers to show confirm dialog
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  return (
    <div className="modal show-modal eob-pdf-viewer d-flex" onClick={onClose}>
      <div
        className="modal-dialog modal-xl d-flex flex-fill"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <div className="modal-content shadow-lg">
          <div className="modal-header">
            <h3 className="modal-title">Explanation Of Benefit Form&nbsp;</h3>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body d-flex flex-fill overflow-hidden p-0">
            <div className="d-flex justify-content-center flex-fill flex-column overflow-hidden">
              {pdfUrl ? (
                <div className="d-flex justify-content-center flex-fill flex-column overflow-hidden">
                  <PdfViewer binaryString={atob(PDF || '')} />
                </div >
              ) : (
                <div>
                  <h2 className="text-center" style={{ color: "#808285" }}>
                    Form Loading, please wait...
                  </h2>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer p-1">
            <div className="alert alert-warning accordion">
              <input type="checkbox" id="single-accordion"/>
              <label className="fw-bold" htmlFor="single-accordion">
                  <i className="bi bi-info-circle-fill"></i>&nbsp;
                  Disclaimer Regarding Coverage, Coding, and Reimbursement
                  <i className="bi bi-chevron-up arrow"></i>
              </label>
              <ol className="m-0 accordion-content">
                <li>This example EOB is provided for informational purposes only. Pacira and EXPARELSupport®
                  does not provide any warranties or guarantees regarding this information, nor for the coverage,
                  coding, and/or reimbursement of the product or fees/costs for administration/procedure/etc. as applicable. Coverage, coding, and reimbursement will vary by payer, plan, region, patient, professional setting, and services rendered, and are all subject to change without notice. Actual coverage and reimbursement decisions are made by individual payers following receipt of claims.</li>
                <li>The information is not intended in any way to replace a full review of benefits by a healthcare provider to determine coverage, coding, and/or reimbursement. Healthcare providers must follow the practices and procedure required by third-party payers when submitting claims for payment.</li>
                <li>This example EOB creates no obligation upon the healthcare provider to prescribe/administer/etc. as applicable, a company product and is in no way intended to replace the independent medical judgment of a healthcare provider. The healthcare provider is responsible to determine whether the product is indicated for and consistent with the medical needs of each patient; eligibility for reimbursement by a particular payer is not a representation that the product is appropriate for that patient.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPdf;
